import http from '@/plugins/axios/axios';

export default class UsuarioService {  

    salvar(requisicao) {       
        return http.post('/api/usuario/salvar', requisicao);
    }

    alterar(requisicao) {       
        return http.post('/api/usuario/alterar', requisicao);
    }

    excluir(requisicao) {       
        return http.post('/api/usuario/excluir', requisicao);
    }

    listar(requisicao) {       
        return http.post('/api/usuario/listar', requisicao);
    }

    listarPerfis(requisicao) {       
        return http.post('/api/usuario/listar-perfis', requisicao);
    }

    buscar(requisicao) {       
        return http.post('/api/usuario/buscar', requisicao);
    }

    buscarEditar(requisicao) {       
        return http.post('/api/usuario/buscar-editar', requisicao);
    }

    alterarSenha(requisicao) {       
        return http.post('/api/usuario/conta/alterar-senha', requisicao);
    }
}